import { render, staticRenderFns } from "./ControlTypeBtnGroup.vue?vue&type=template&id=7897ed4b&scoped=true&"
import script from "./ControlTypeBtnGroup.vue?vue&type=script&lang=js&"
export * from "./ControlTypeBtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./ControlTypeBtnGroup.vue?vue&type=style&index=0&id=7897ed4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897ed4b",
  null
  
)

export default component.exports